<template>
  <div class="h-full flex flex-col bg-[#f8fafc] gap-4 overflow-auto pr-2">
    <div class="bg-white rounded-xl shadow-sm border border-slate-200 overflow-visible border-t-4 border-t-[#0d4169]">
      <div class="px-6 pt-5 pb-3">
        <!-- <h2 class="text-base font-bold text-[#0d4169]">Menu Engineering Report</h2> -->
      </div>
      <div class="px-6 pb-6 text-sm text-slate-600">
        <!-- This report is not implemented yet. -->
      </div>
    </div>
  </div>
</template>

<script setup>
</script>

